import { conConfig } from "@victorequena22/conneccion";
import { toast } from "react-toastify";
export const getSMS = async (url: string, id: string | number, sms: string, update: () => void) => {
    if (sms !== '') conConfig('').post(`/api/Programa/Suscribirse/sms/${url}/${id}`, { sms },
        () => { update(); toast('GUARDADO EXITOSAMENTE', { type: toast.TYPE.SUCCESS }) },
        () => { update(); toast('ERROR', { type: toast.TYPE.ERROR }) })
}
export const getChat = async (url: string, id: string | number, set: (d: any) => void) => {
    conConfig('').get(`/api/Programa/Suscribirse/chat/${url}/${id}`, set)
}